module.exports = __webpack_public_path__ + "static/media/ceilings_allImpact_10y_y.85368bf2.csv";